import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import LOOKUP_TYPES from '../../common/constants/SuccessPlanConstants';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import {
  fetchMilestoneStatusLookupsV2,
  fetchMilestonesV2,
  fetchMilestoneByIdV2,
  fetchMilestoneStatusV2,
  completeMilestoneV2,
  markMilestoneInprogressV2,
  archiveMilestoneV2,
  createMilestoneV2,
  editMilestoneV2,
  refreshMilestoneBoardByIdV2,
} from '../routines/successPlanRoutines';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

const SUCCESS_PLAN_BASE_URL = `${envConfig.APIG_URL}success-plan`;

function* fetchMilestonesSagaV2({ payload }) {
  try {
    const { successPlanId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone`;
    const response = yield call(request, url);
    const milestones = response.data;
    yield put(fetchMilestonesV2.success(milestones));
    for (let i = 0; i < milestones.length; i += 1) {
      const milestone = milestones[i];
      const { milestoneId } = milestone;
      yield put(
        fetchMilestoneByIdV2.trigger({
          successPlanId,
          milestoneId,
        })
      );
    }
  } catch (error) {
    yield put(fetchMilestonesV2.failure({ error }));
  } finally {
    yield put(fetchMilestonesV2.fulfill());
  }
}
function* fetchMilestoneByIdSagaV2({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}`;
    const response = yield call(request, url);
    yield put(fetchMilestoneByIdV2.success(response.data));
  } catch (error) {
    yield put(fetchMilestoneByIdV2.failure({ error }));
  } finally {
    yield put(fetchMilestoneByIdV2.fulfill());
  }
}

function* fetchMilestoneStatusLookupsSagaV2() {
  try {
    const url = `${SUCCESS_PLAN_BASE_URL}/lookup?type=${LOOKUP_TYPES.MILESTONE_STATUS}`;
    const response = yield call(request, url);
    yield put(fetchMilestoneStatusLookupsV2.success(response.data));
  } catch (error) {
    yield put(fetchMilestoneStatusLookupsV2.failure({ error }));
  } finally {
    yield put(fetchMilestoneStatusLookupsV2.fulfill());
  }
}

function* fetchMilestoneStatusSagaV2({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/status`;
    const response = yield call(request, url);
    yield put(fetchMilestoneStatusV2.success(response.data));
  } catch (error) {
    yield put(fetchMilestoneStatusV2.failure({ error }));
  } finally {
    yield put(fetchMilestoneStatusV2.fulfill());
  }
}

function* completeMilestoneSagaV2({ payload }) {
  try {
    const { successPlanId, milestoneId, completeAll } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/complete?complete_all=${!!completeAll}`;
    const response = yield call(request, url, { method: 'PUT', payload: {} });

    yield put(
      completeMilestoneV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.COMPLETE_SUCCESS_PLAN_MILESTONE,
      })
    );
    yield put(
      fetchMilestonesV2.trigger({
        successPlanId,
      })
    );
    yield put(
      fetchMilestoneByIdV2.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(completeMilestoneV2.failure({ error }));
  } finally {
    yield put(completeMilestoneV2.fulfill());
  }
}

function* markMilestoneInprogressSagaV2({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/uncomplete`;
    const response = yield call(request, url, { method: 'PUT', payload: {} });

    yield put(
      markMilestoneInprogressV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.IN_PROGRESS_SUCCESS_PLAN_MILESTONE,
      })
    );
    yield put(
      fetchMilestonesV2.trigger({
        successPlanId,
      })
    );
    yield put(
      fetchMilestoneByIdV2.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(markMilestoneInprogressV2.failure({ error }));
  } finally {
    yield put(markMilestoneInprogressV2.fulfill());
  }
}

function* archiveMilestoneSagaV2({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/archive`;
    const response = yield call(request, url, { method: 'PATCH', payload: {} });

    yield put(
      archiveMilestoneV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.ARCHIVE_SUCCESS_PLAN_MILESTONE,
      })
    );
    yield put(fetchMilestonesV2.trigger({ successPlanId }));
    yield put(
      fetchMilestoneByIdV2.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(archiveMilestoneV2.failure({ error }));
  } finally {
    yield put(archiveMilestoneV2.fulfill());
  }
}
function* createMilestoneSagaV2({ payload }) {
  try {
    const { successPlanId, milestone, onSuccess } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone`;
    const {
      name,
      description,
      startDate,
      dueDate,
      ownerId,
      collaborators,
      statusId,
      taskIds,
    } = milestone;

    const config = {
      method: 'POST',
      payload: {
        name,
        description,
        dueDate: dueDate.format('YYYY-MM-DD'),
        startDate: startDate.format('YYYY-MM-DD'),
        ownerId,
        collaborators,
        statusId,
        taskIds,
      },
    };
    const response = yield call(request, url, config);
    if (onSuccess) {
      onSuccess(response.data);
    }
    yield put(
      createMilestoneV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.ADD_SUCCESS_PLAN_MILESTONE,
      })
    );
    yield put(
      fetchMilestonesV2.trigger({
        successPlanId,
      })
    );
  } catch (error) {
    yield put(createMilestoneV2.failure({ error }));
  } finally {
    yield put(createMilestoneV2.fulfill());
  }
}

function* editMilestoneSagaV2({ payload }) {
  try {
    const { milestone, successPlanId, milestoneId, onSuccess } = payload;
    const {
      name,
      description,
      startDate,
      dueDate,
      ownerId,
      collaborators,
      statusId,
      taskIds,
    } = milestone;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}`;
    const config = {
      method: 'PUT',
      payload: {
        name,
        description,
        dueDate: dueDate.format('YYYY-MM-DD'),
        startDate: startDate.format('YYYY-MM-DD'),
        ownerId,
        statusId,
        collaborators,
        taskIds,
      },
    };
    const response = yield call(request, url, config);
    yield put(
      editMilestoneV2.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.EDIT_SUCCESS_PLAN_MILESTONE,
      })
    );
    if (onSuccess) {
      onSuccess(response.data);
    }
    yield put(
      fetchMilestoneByIdV2.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(editMilestoneV2.failure({ error }));
  } finally {
    yield put(editMilestoneV2.fulfill());
  }
}

function* refreshBoardMilestoneSaga({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}`;
    const response = yield call(request, url);
    yield put(refreshMilestoneBoardByIdV2.success(response.data));
  } catch (error) {
    yield put(refreshMilestoneBoardByIdV2.failure({ error }));
  } finally {
    yield put(refreshMilestoneBoardByIdV2.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(
      fetchMilestoneStatusLookupsV2.TRIGGER,
      fetchMilestoneStatusLookupsSagaV2
    ),
    takeLatest(fetchMilestonesV2.TRIGGER, fetchMilestonesSagaV2),
    takeEvery(fetchMilestoneByIdV2.TRIGGER, fetchMilestoneByIdSagaV2),
    takeLatest(fetchMilestoneStatusV2.TRIGGER, fetchMilestoneStatusSagaV2),
    takeLatest(completeMilestoneV2.TRIGGER, completeMilestoneSagaV2),
    takeLatest(
      markMilestoneInprogressV2.TRIGGER,
      markMilestoneInprogressSagaV2
    ),
    takeLatest(archiveMilestoneV2.TRIGGER, archiveMilestoneSagaV2),
    takeLatest(createMilestoneV2.TRIGGER, createMilestoneSagaV2),
    takeLatest(editMilestoneV2.TRIGGER, editMilestoneSagaV2),
    takeEvery(refreshMilestoneBoardByIdV2.TRIGGER, refreshBoardMilestoneSaga),
  ]);
}
